// extracted by mini-css-extract-plugin
module.exports = {"logo_container":"Topbar_logo_container__4nDdW"};